import {
  ADD_CAMPAIGN,
  UPDATE_CAMPAIGN,
  ADD_VIDEO,
  UPDATE_VIDEO,
  UPDATE_CAMPAIGN_NAME
} from '../actions'

export default function campaignReducer (state, action) {
  switch (action.type) {
    case ADD_CAMPAIGN:
      return {
        ...state,
        activeAccount: {
          ...state.activeAccount,
          campaigns: state.campaigns.concat(action.campaign)
        }
      }
    case UPDATE_CAMPAIGN: {
      let campaigns = state.activeAccount.campaigns.map((campaign) => {
        if (campaign.id === action.campaign.id) {
          return action.campaign
        }
        return campaign
      })
      return {
        ...state,
        activeAccount: {
          ...state.activeAccount,
          campaigns
        }
      }
    }
    case ADD_VIDEO: {
      let campaigns = state.campaigns.reduce((initial, campaign) => {
        if (campaign.id === action.payload.campaignId) {
          let updatedCampaign = {
            ...campaign,
            videos: [
              ...campaign.videos,
              action.payload.video
            ]
          }
          initial.push(updatedCampaign)
        } else {
          initial.push(campaign)
        }
        return initial
      }, [])
      return {
        ...state,
        activeAccount: {
          ...state.activeAccount,
          campaigns
        }
      }
    }
    case UPDATE_CAMPAIGN_NAME:
      let newCampaigns = updateCampaignName(state, action.campaign)
      return {
        ...state,
        activeAccount: {
          ...state.activeAccount,
          campaigns: newCampaigns
        }
      }
    case UPDATE_VIDEO:
      let newcampaigns = updateVideo(state, action.payload)
      return {
        ...state,
        activeAccount: {
          ...state.activeAccount,
          campaigns: newcampaigns
        }
      }
    default:
      return state
  }
}

function updateVideo (state, payload) {
  let campaigns = state.activeAccount.campaigns.map((campaign) => {
    if (campaign.id === payload.campaignId) {
      let videos = campaign.videos.map((video) => {
        if (video.id === payload.video.id) {
          video = payload.video
        }
        return video
      })
      campaign.videos = videos
    }
    return campaign
  })
  return campaigns
}

function updateCampaignName (state, campaign) {
  return state.activeAccount.campaigns.map(c => {
    if (c.id === campaign.id) {
      c.name = campaign.name
    }
    return c
  })
}



// WEBPACK FOOTER //
// ./src/reducers/campaignReducer.js